import { useState } from "react";

import { Button, Modal, Stack, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { useWriterComponentState } from "hooks";
import { MODAL_STYLE } from "layouts/constants";

import { ClientAppEvent } from "../../../../constants";
import { EmailNotificationPreferences } from "../EmailNotificationPreferences";

interface Props {
  shipment: ShipperCondensedShipment;
  onModalClose: VoidFunction;
  onSettingsUpdated: VoidFunction;
  modalOpen: boolean;
}

export function UpdateShipmentEmailNotificationSettingsModal(props: Props) {
  const { modalOpen, shipment, onModalClose, onSettingsUpdated } = props;
  const posthog = usePostHog();
  const [settings, setSettings] = useState<ShipperEmailNotificationType>(
    shipment.email_notification_settings ?? "ALL",
  );
  const { loading, write, error } = useWriterComponentState({
    errorMessage:
      "Failed to update email settings. Please contact us if the issue persists",
    writeConfig: {
      method: "patch",
      url: shipment?.info?.id ? `/shipments/${shipment.info.id}/update` : "/",
      body: { email_notification_settings: settings },
    },
  });
  const submit = () => {
    write(() => {
      posthog?.capture(ClientAppEvent.SHIPMENT_EMAIL_NOTIFICATIONS_UPDATED, {
        email_enabled: settings || undefined,
      });
      onSettingsUpdated();
    });
  };
  return (
    <Modal open={modalOpen} onClose={onModalClose}>
      <Stack sx={MODAL_STYLE} direction="column" spacing={1}>
        <Typography variant="h6">Update Notification Preferences</Typography>
        <EmailNotificationPreferences
          value={settings}
          onChange={(newValue) => setSettings(newValue)}
          isProject={shipment.info?.type === "MULTI_SHIPMENT_PROJECT"}
        />
        <LoadingWrappedNode loading={loading}>
          <Stack alignItems="center" mt="1rem">
            <Button variant="contained" onClick={submit}>
              Submit
            </Button>
          </Stack>
        </LoadingWrappedNode>

        <ErrorTypography error={error} />
      </Stack>
    </Modal>
  );
}
